<template>
  <div class="flex items-center gap-spacing_4">
    <div
      v-for="(step, index) in steps"
      class="group flex items-center gap-spacing_4"
    >
      <Separator
        variant="horizontal"
        weight="bold"
        class="w-8 group-first:hidden"
        :class="{
          '!border-primary-300': currentStep < index,
          '!border-action': currentStep >= index,
        }"
      />

      <Step
        class="step"
        :step="index + 1"
        :title="step"
        :state="
          currentStep < index
            ? 'locked'
            : currentStep > index
              ? 'complete'
              : 'default'
        "
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { StepperProps } from "~/types/schemas/common/Molecule/stepper";
import Separator from "~/components/common/Atom/Separator.vue";
import Step from "~/components/common/Atom/Step.vue";

defineProps<StepperProps>();
</script>

<style scoped>
.step :deep(.step-title) {
  @apply hidden md:inline;
}
</style>
